import { render, staticRenderFns } from "./InputSigarusTextarea.vue?vue&type=template&id=50b7f4ab"
import script from "./InputSigarusTextarea.vue?vue&type=script&lang=js"
export * from "./InputSigarusTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports